/**
 * If either :// or // is present consider it to be an absolute url
 *
 * @param url string
 */
function isAbsoluteUrl(url) {
  return new RegExp(`(^|:)//`).test(url);
}

export { isAbsoluteUrl };
//# sourceMappingURL=isAbsoluteUrl.js.map
